module.exports = __webpack_public_path__ + "src/images/products/allAmerican/74_MA-1 Cotton Bomber.png";